import { Skeleton } from '@accure/ui';

import { Card } from '@/components/ui/card';
import { ProjectShell } from '@/project-management/components/layout/project-shell';
import {
  CompletedTasksLegend,
  OpenTasksLegend,
} from '@/project-management/pages/timeline/components/task-priority-legend';

export function TimelineLoading() {
  return (
    <ProjectShell className="space-y-4">
      <Card className="space-y-4 p-6">
        <div className="h-[300px] w-full overflow-hidden rounded bg-white shadow-sm">
          <div className="relative size-full">
            <div className="absolute inset-0">
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '-0.0246548%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '4.11736%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '8.25937%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '12.4014%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '16.5434%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '20.6854%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '24.8274%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '28.9694%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '33.1114%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '37.2535%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '41.3955%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '45.5375%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '49.6795%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '53.7968%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '57.9389%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '62.0809%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '66.2229%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '70.3649%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '74.5069%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '78.6489%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '82.7909%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '86.9329%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '91.075%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '95.217%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
              <div
                className="absolute inset-y-0 h-full border-l border-gray-200"
                style={{ left: '99.359%' }}
              >
                <span className="absolute left-2 top-1 cursor-default text-xs text-gray-300 hover:text-gray-500">
                  <Skeleton className="size-4" />
                </span>
              </div>
            </div>
            <div className="pt-12">
              <div className="relative mb-4 h-16">
                <Skeleton
                  className="absolute top-0 h-4 w-24 whitespace-nowrap text-sm font-medium text-gray-900"
                  style={{ left: '1.18343%' }}
                />
                <Skeleton
                  className="absolute h-4"
                  style={{ left: '1.18343%', width: '35.503%', top: '30px' }}
                />
              </div>
              <div className="relative mb-4 h-16">
                <Skeleton
                  className="absolute top-0 h-4 w-24 whitespace-nowrap text-sm font-medium text-gray-900"
                  style={{ left: '36.0947%' }}
                />
                <Skeleton
                  className="absolute h-4"
                  style={{ left: '36.0947%', width: '45.5621%', top: '30px' }}
                />
              </div>
              <div className="relative mb-4 h-16">
                <Skeleton
                  className="absolute top-0 h-4 w-24 whitespace-nowrap text-sm font-medium text-gray-900"
                  style={{ left: '90.5326%' }}
                />
                <Skeleton
                  className="absolute h-4"
                  style={{ left: '90.5326%', width: '9.46746%', top: '30px' }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex gap-8 border-t border-gray-200 pt-4 text-sm text-neutral-600 [&>*]:min-w-40">
          <CompletedTasksLegend />
          <OpenTasksLegend />
        </div>
      </Card>
    </ProjectShell>
  );
}
